import {
  HomeIcon,
  BuildingOffice2Icon,
  UserGroupIcon,
  DocumentTextIcon,
  PaperClipIcon,
  CogIcon,
  ClipboardDocumentIcon,
  ClipboardDocumentCheckIcon,
  DocumentArrowDownIcon,
} from '@heroicons/react/24/outline';
import { SVGProps } from 'react';

interface NavigationRoute {
  name: string;
  icon: (
    props: SVGProps<SVGSVGElement> & { title?: string | undefined; titleId?: string | undefined },
  ) => JSX.Element;
  path: string;
}

export const companyNavigation: NavigationRoute[] = [
  {
    name: 'navigation.dashboard',
    icon: HomeIcon,
    path: '/dashboard',
  },
  {
    name: 'navigation.new-document',
    icon: DocumentTextIcon,
    path: '/new-document',
  },
  {
    name: 'navigation.documents',
    icon: DocumentTextIcon,
    path: '/documents',
  },
  {
    name: 'navigation.files',
    icon: PaperClipIcon,
    path: '/files',
  },
  {
    name: 'navigation.code-book-items',
    icon: ClipboardDocumentIcon,
    path: '/code-book-items',
  },
  {
    name: 'navigation.user-tasks',
    icon: ClipboardDocumentCheckIcon,
    path: '/user-tasks',
  },
  {
    name: 'navigation.issued-document-export',
    icon: DocumentArrowDownIcon,
    path: '/issued-documents-export',
  },
  {
    name: 'navigation.company-setting',
    icon: CogIcon,
    path: '/my-companies/edit/current',
  },
];

export const userNavigation: NavigationRoute[] = [
  {
    name: 'navigation.my-companies',
    icon: BuildingOffice2Icon,
    path: '/my-companies',
  },
  {
    name: 'navigation.my-teams',
    icon: UserGroupIcon,
    path: '/my-teams',
  },
];

export const allRoutes: NavigationRoute[] = [...companyNavigation, ...userNavigation];
